import ApiClient from './ApiClient';

class SyonetConnectionsAPI extends ApiClient {
    constructor() {
        super('syonet_connections', { accountScoped: true });
    }

    testConnection(syonetConnection) {
        return axios.post(`${this.url}/test_connection`, { syonet_connection: syonetConnection });
    }
}

export default new SyonetConnectionsAPI();
